// Only these two promotional-event types ever reach a payment and have somewhere
// of their own to send the payer afterwards. A seminar/webinar registration is
// free and never creates an order at all, and every other kind of order keeps the
// organisation's default redirect.
const PROMOTIONAL_EVENT_TYPE_PATH_SEGMENT = {
  scholarship: 'open-mock-test',
  admissions: 'program-admissions',
};

// A successful payment is the moment one of these registrations actually
// completes, so Continue leads to the event's thank-you page rather than back to
// the page the student registered from.
//
// The order names that page itself - orderMeta.postPaymentRedirectUrl, stamped by
// core-backend at order creation - so ordergate never has to know how those URLs
// are spelled, only how to refuse one it cannot use. The check matters because the
// value ends up in window.location: it is written server-side today, but that is
// not a thing to depend on at a redirect.
function resolveThankYouUrl(order) {
  const requestedUrl = order?.orderMeta?.postPaymentRedirectUrl;
  if (!requestedUrl) return null;

  try {
    const { protocol } = new URL(requestedUrl);
    return protocol === 'https:' || protocol === 'http:' ? requestedUrl : null;
  } catch (error) {
    return null;
  }
}

function getPromotionalEventRedirectUrl({ organizationData, order }) {
  const promotionalEventType = order?.orderMeta?.promotionalEventType;
  const promotionalEventSlug = order?.orderMeta?.promotionalEventSlug;
  const pathSegment = PROMOTIONAL_EVENT_TYPE_PATH_SEGMENT[promotionalEventType];

  if (!pathSegment || !promotionalEventSlug || !organizationData?.websiteBaseUrl) {
    return null;
  }

  const eventUrl = `${organizationData.websiteBaseUrl}/${pathSegment}/${encodeURIComponent(promotionalEventSlug)}`;

  return {
    successUrl: resolveThankYouUrl(order) || eventUrl,
    // A failed payment completed nothing, so it goes back to the event page it has
    // always gone back to - there is nothing there to thank anyone for. It is also
    // the fallback for a success on an order created before postPaymentRedirectUrl
    // was stamped, which is exactly the behaviour those orders had all along.
    failureUrl: eventUrl,
  };
}

export default getPromotionalEventRedirectUrl;
